import { useEffect, useState } from "react";
import { Cookie, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { getConsent, setConsent, initGA, trackPageView } from "@/lib/analytics";

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Mostra il banner solo se l'utente non ha ancora scelto
    if (!getConsent()) {
      const t = setTimeout(() => setVisible(true), 600);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    setConsent("granted");
    setVisible(false);
    // Carica GA solo ora, dopo il consenso
    initGA();
    trackPageView(window.location.pathname + window.location.search);
  };

  const reject = () => {
    setConsent("denied");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Consenso cookie"
      data-testid="cookie-consent-banner"
      className="fixed inset-x-0 bottom-0 z-[300] p-4 sm:p-6"
    >
      <div className="relative mx-auto max-w-4xl rounded-2xl border border-border bg-card/95 p-5 shadow-2xl backdrop-blur-md sm:p-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-start gap-3">
            <span className="mt-0.5 inline-flex h-10 w-10 flex-none items-center justify-center rounded-xl bg-primary/10 text-primary">
              <Cookie className="h-5 w-5" strokeWidth={2} />
            </span>
            <div>
              <h3 className="font-display text-base font-bold text-foreground">Rispettiamo la tua privacy</h3>
              <p className="mt-1 text-sm leading-6 text-muted-foreground">
                Usiamo cookie di statistica (Google Analytics) per capire quante persone visitano il sito e migliorarlo.
                Nessun cookie di tracciamento viene attivato senza il tuo consenso. Consulta la{" "}
                <a href="/privacy" className="underline hover:text-foreground">Privacy Policy</a>.
              </p>
            </div>
          </div>
          <div className="flex flex-none flex-col gap-2 sm:flex-row sm:items-center">
            <Button
              variant="outline"
              onClick={reject}
              data-testid="cookie-consent-reject"
              className="h-11 rounded-full px-6"
            >
              Rifiuta
            </Button>
            <Button
              onClick={accept}
              data-testid="cookie-consent-accept"
              className="btn-cta h-11 px-6"
            >
              Accetta
            </Button>
          </div>
        </div>
        <button
          type="button"
          onClick={reject}
          aria-label="Chiudi e rifiuta"
          data-testid="cookie-consent-close"
          className="absolute right-3 top-3 hidden text-muted-foreground transition-colors duration-200 hover:text-foreground sm:block"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};
